/* Phase A stub screens.
 *
 * Each route in src/app/routes.tsx that doesn't yet have its real
 * Comcast-ported implementation renders one of these. Per the
 * 2026-05-21 memory entry: port screen-by-screen, not bulk. Phase B
 * replaces each stub with the real screen, insurance content swapped
 * in. Roleplay and Debrief are already real (our Phase 1 scaffold)
 * so they're not stubbed.
 */

import { Link } from 'react-router-dom';

interface StubProps {
  name: string;
  blurb?: string;
  nextStep?: string;
}

function ScreenStub({ name, blurb, nextStep }: StubProps) {
  return (
    <section className="screen-stub">
      <div className="screen-stub__card">
        <span className="screen-stub__eyebrow">Coming soon</span>
        <h1 className="screen-stub__title">{name}</h1>
        {blurb && <p className="screen-stub__blurb">{blurb}</p>}
        {nextStep && <p className="screen-stub__next">{nextStep}</p>}
        <Link to="/" className="screen-stub__back">
          ← Back home
        </Link>
      </div>
    </section>
  );
}

export function DebriefStub() {
  return (
    <ScreenStub
      name="Debrief"
      blurb="Post-session review. Hero verdict + Coach narrative + saveable moments."
      nextStep="Real debrief lives at /debrief/:sessionId."
    />
  );
}
